import { executionReportsDatabase } from '../indexedDB'

export default (reportDataId = '') => {
    return new Promise((resolve) => {
        const fetchReport = async () => {
            const db = await executionReportsDatabase.initDb()
            const { database } = db
            const response = await executionReportsDatabase.consultar(database)
            const executionReport = response.filter((element) => element.reportId === reportDataId)
            if (executionReport.length > 0) {
                resolve({
                    state: true,
                    data: executionReport[0]
                })
            } else {
                resolve({
                    state: false,
                    data: {
                        message: 'Sin datos'
                    }
                })
            }
        }
        fetchReport()
    })
}
